import { AxUser } from '@/types/AxUserType'
import { CartDisplayItem } from '@/types/carts'

// header.phpで、AxE-V-Componentで読み込む
export const header = {
  data() {
    return {
      initialized: false,
      cartCount: 0,
      userProfile: null as AxUser,
    }
  },
  components: {},
  mounted() {
    this.init()
  },
  computed: {
    isLoggedIn() {
      return this.$AxE2.isLoggedIn
    },
  },
  methods: {
    async init() {
      Promise.all([
        async () => {
          const cartItems = (await this.$AxE2.$cart.getCartFromApi()) as CartDisplayItem
          this.cartCount = cartItems.standardCartItemData.items.length + cartItems.regularCartItemData.items.length
        },
        async () => {
          this.userProfile = (await this.$AxE2.$auth.getCurrentLoggedInUserProfile()) as AxUser
        },
      ])

      this.initialized = true
    },
    async signOut() {
      await this.$AxE2.$auth.signOut()
    },
  },
}
//
